import { FilterObject } from './filter-object';
import * as lodash from 'lodash';

export class StartWithFilter extends FilterObject<any> {

  public filter(itemToFiltre: any): boolean {
    return this.doFilter(itemToFiltre, this.field, this.values);
  }

  public doFilter(itemToFiltre: any, field: any, value: any): boolean {
    if (value == null) {
      return true;
    }
    let result = false;
    let words = itemToFiltre[field].split(' ');
    words.forEach((element: any) => {

      let comp = lodash.deburr(element);
      comp = lodash.lowerCase(element);

      value = lodash.deburr(value);
      value = lodash.lowerCase(value);

      result = result || comp.startsWith(value);
    })
    return result;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/startwith.filter.ts